module.exports = __webpack_public_path__ + "img/ticked-checkbox.f6627a9b.svg";